import { SelectedRoute } from "module/eddm/dto";

export const getRouteResidences = (selectedRoutes: SelectedRoute[]): number => {
  if (!selectedRoutes?.length) return 0;
  return selectedRoutes.reduce((acc, curr) => {
    return acc + curr.metadata.APT_COUNT + curr.metadata.HOME_COUNT;
  }, 0);
};
